module.exports = __webpack_public_path__ + "static/media/right-menu-video-tutorial-icon.7e8e06db.svg";